module.exports = __webpack_public_path__ + "img/microsoft-edge.223152bd.svg";